
import { EventDispatcher } from "../application/EventDispatcher";
import i18n from "i18next";
import { isTouchDevice, touchStartToClick } from "../compat";
import { GlobalManagerMixin } from "../application/GlobalManagerMixin";

import { Hammer } from '../imports/conditional/browser/hammer.js';

export class OptionSlider extends EventDispatcher {

  constructor(caption, min, max, parentTbody, options) {
    super();

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.hideStepper = options && options.hideStepper;
    var hideCaption = options && options.hideCaption;
    this.sliderRow = this.tbody.insertRow(atIndex);
    this.sliderRow.classList.add("switch-slider-row");

    var _document = this.getDocument();
    var cell = this.sliderRow.insertCell(0);
    this.caption = _document.createElement("div");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption);
    if (hideCaption) this.caption.style.display = "none";
    cell.appendChild(this.caption);

    cell = this.sliderRow.insertCell(1);
    this.sliderElement = _document.createElement("input");
    this.sliderElement.type = "range";
    this.sliderElement.id = caption + "_slider";
    this.sliderElement.min = min;
    this.sliderElement.max = max;
    this.sliderElement.style.width = "85%";
    cell.appendChild(this.sliderElement);

    cell = this.sliderRow.insertCell(2);

    this.stepperElement = _document.createElement("input");
    this.stepperElement.type = "number";
    this.stepperElement.id = caption + "_stepper";
    this.stepperElement.min = min;
    this.stepperElement.max = max;
    this.stepperElement.step = 1;
    this.stepperElement.style.width = "64px";
    if (this.hideStepper) this.stepperElement.style.display = "none";
    cell.appendChild(this.stepperElement);

    this.blockEvent = false;

    this.stepperElement.addEventListener("change",
    (e) => {
      if (e.target != this.sliderElement)
      this.sliderElement.value = this.stepperElement.value;
      this.fireChangeEvent();
    }, false);

    const changeHandler = (e) => {
      if (e.target != this.stepperElement)
      this.stepperElement.value = this.sliderElement.value;
      this.fireChangeEvent();
    };

    this.sliderElement.addEventListener("change", changeHandler, false);
    this.sliderElement.addEventListener("input", changeHandler, false);
  }

  fireChangeEvent() {
    if (!this.blockEvent) {
      this.value = this.sliderElement.value;
      var e = new CustomEvent("change", {
        detail: {
          target: this,
          value: this.sliderElement.value
        }
      });
      this.dispatchEvent(e);
    }
  }

  setValue(v) {
    this.blockEvent = true;
    this.value = v;
    this.sliderElement.value = v;
    this.stepperElement.value = v;
    this.blockEvent = false;
  }

  setDisabled(v) {
    this.sliderElement.disabled = v;
    this.stepperElement.disabled = v;
    this.caption.disabled = v;
  }
}
GlobalManagerMixin.call(OptionSlider.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

export class OptionCheckbox extends EventDispatcher {

  constructor(caption, parentTbody, initialState, description, globalManager, options) {
    super();

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.sliderRow = this.tbody.insertRow(atIndex);
    this.sliderRow.classList.add("switch-slider-row");

    var _document = this.getDocument();
    var cell = this.sliderRow.insertCell(0);
    this.caption = _document.createElement("div");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption, options?.i18nOptions);

    cell.appendChild(this.caption);

    if (options && options.betaLabel === true) {
      // In theory, we could also add the beta label to caption directly. However, caption is tagged for translation itself.
      // For such elements, initializeLocalization() in i18n.t just sets the textContent to the translated string.
      // So, any children added to i18n elements would currently disappear as soon as a second viewer instance is started.
      let betaLabelParent = _document.createElement("div");
      cell.appendChild(betaLabelParent);

      let betaLabel = _document.createElement("div");
      betaLabel.setAttribute("data-i18n", "BETA");
      betaLabel.textContent = i18n.t("BETA", options?.i18nOptions);
      betaLabel.classList.add("switch-slider-row-beta-label");
      betaLabelParent.appendChild(betaLabel);
    }

    cell = this.sliderRow.insertCell(1);

    if (description) {
      this.description = _document.createElement("div");
      this.description.setAttribute("data-i18n", description);
      this.description.textContent = i18n.t(description, options?.i18nOptions);

      cell.appendChild(this.description);
      cell = this.sliderRow.insertCell(2);
    }

    var label = _document.createElement("label");
    label.classList.add("switch");

    this.checkElement = _document.createElement("input");
    this.checkElement.type = "checkbox";
    this.checkElement.id = caption + "_check";
    this.checkElement.checked = initialState;
    label.appendChild(this.checkElement);

    var div = _document.createElement("div");
    div.classList.add("slider");
    label.appendChild(div);

    cell.appendChild(label);

    this.blockEvent = false;
    this.checked = initialState;

    this.checkElement.addEventListener("change",
    (e) => {
      this.fireChangeEvent();
    }, false);

    if (isTouchDevice()) {
      // Tap on a checkbox is handled by the browser so we don't hav to do anything for it.

      this.sliderRowHammer = new Hammer.Manager(this.sliderRow, {
        recognizers: [[Hammer.Tap]],
        handlePointerEventMouse: false,
        inputClass: Hammer.TouchInput
      });
      this.sliderRowHammer.on("tap", (e) => {
        e.preventDefault();
        //e.stopPropagation(); // Doesn't exist for tap events.
        e.target.click();
      });
    }

    this.checkElement.addEventListener("click", function (event) {
      event.stopPropagation();
    }, false);

    // Make the slider row clickable as well so that when
    // clicking on the row, the checkbox is toggled.
    this.sliderRow.addEventListener("click",
    (e) => {
      if (!this.checkElement.disabled) {
        this.checkElement.checked = !this.checkElement.checked;
        this.fireChangeEvent();
      }
    }, false);

    if (globalManager) {
      this.setGlobalManager(globalManager);
    }
  }

  fireChangeEvent() {
    if (!this.blockEvent) {
      this.checked = this.checkElement.checked;
      var e = new CustomEvent("change", {
        detail: {
          target: this,
          value: this.checkElement.checked
        }
      });
      this.dispatchEvent(e);
    }
  }

  setChecked(check) {
    if (this.checkElement.checked != check)
    {
      this.checkElement.checked = check;
      this.fireChangeEvent();
    }
  }

  setValue(v) {
    this.blockEvent = true;
    this.checked = v;
    this.checkElement.checked = v;
    this.blockEvent = false;
  }

  getValue() {
    var v = this.checkElement.checked;
    return v;
  }

  setDisabled(v) {
    this.checkElement.disabled = v;
    this.caption.disabled = v;
  }

  setVisibility(isVisible) {
    if (isVisible)
    this.sliderRow.style.display = "table-row";else

    this.sliderRow.style.display = "none";
  }
}
GlobalManagerMixin.call(OptionCheckbox.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================
export class OptionLabel {

  constructor(caption, parentTbody, globalManager, options) {

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.sliderRow = this.tbody.insertRow(atIndex);

    var _document = this.getDocument();
    var cell = this.sliderRow.insertCell(0);
    this.caption = _document.createElement("span");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption);
    cell.appendChild(this.caption);

    cell.colSpan = "3";

    this.blockEvent = false;
  }

  /**
   * Removes the label from DOM.
   */
  removeFromParent() {
    this.tbody.removeChild(this.sliderRow);
    this.tbody = null;
    this.sliderRow = null;
    this.caption = null;
  }
}
GlobalManagerMixin.call(OptionLabel.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

export class OptionButton {

  constructor(caption, parentTbody, globalManager, options) {

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.sliderRow = this.tbody.insertRow(atIndex);

    this.sliderRow.insertCell(); // discard first
    var cell = this.sliderRow.insertCell();
    this.sliderRow.insertCell(); // discard third

    var _document = this.getDocument();
    this.caption = _document.createElement("div");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption);
    this.caption.classList.add('adsk-button');
    this.caption.classList.add('table-button');
    cell.appendChild(this.caption);
  }

  /**
   * Removes the button from DOM.
   */
  removeFromParent() {
    this.tbody.removeChild(this.sliderRow);
    if (this._onClick) {
      this.caption.removeEventListener('click', this._onClick);
      this._onClick = null;
    }
    this.tbody = null;
    this.sliderRow = null;
    this.caption = null;
  }

  /**
   * Registers a click callback.
   * @param {function} onClick - click function callback.
   */
  setOnClick(onClick) {
    this._onClick = onClick;
    this.caption.addEventListener('touchstart', touchStartToClick, false);
    this.caption.addEventListener('click', onClick, false);
  }
}
GlobalManagerMixin.call(OptionButton.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

export class OptionDropDown extends EventDispatcher {

  constructor(caption, parentTbody, items, initialItemIndex, envtab, globalManager, options) {
    super();

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.sliderRow = this.tbody.insertRow(atIndex);

    var _document = this.getDocument();
    this.dropdownElement = _document.createElement("select");
    this.dropdownElement.id = caption + "_dropdown";
    this.dropdownElement.classList.add("option-drop-down");

    for (var i = 0; i < items.length; i++) {
      var item = _document.createElement("option");
      item.value = i;
      item.setAttribute("data-i18n", items[i]);
      item.textContent = i18n.t(items[i]);
      this.dropdownElement.add(item);
    }

    this.selectedIndex = this.dropdownElement.selectedIndex = initialItemIndex;

    var cell = this.sliderRow.insertCell(0);
    this.caption = _document.createElement("div");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption);
    cell.appendChild(this.caption);

    if (envtab) {
      cell.colSpan = "2";

      this.sliderRow = this.tbody.insertRow(atIndex);
      cell = this.sliderRow.insertCell(0);
      cell.appendChild(this.dropdownElement);
      cell.colSpan = "2";
      this.dropdownElement.classList.add('tabcell');
    } else
    {
      cell = this.sliderRow.insertCell(1);
      cell.appendChild(this.dropdownElement);
    }

    cell.style.paddingLeft = (options && options.paddingLeft !== undefined ? options.paddingLeft : 0) + 'px';
    cell.style.paddingRight = (options && options.paddingRight !== undefined ? options.paddingRight : 0) + 'px';
    this.blockEvent = false;

    this.dropdownElement.addEventListener("change",
    (e) => {
      this.fireChangeEvent();
    }, false);
  }

  setSelectedIndex(index) {
    this.blockEvent = true;
    this.selectedIndex = this.dropdownElement.selectedIndex = index;
    this.blockEvent = false;
  }

  setSelectedValue(value) {
    this.blockEvent = true;
    this.dropdownElement.selectedValue = value;
    this.selectedIndex = this.dropdownElement.selectedIndex;
    this.blockEvent = false;
  }

  fireChangeEvent() {
    if (!this.blockEvent) {
      this.selectedIndex = this.dropdownElement.selectedIndex;
      var e = new CustomEvent("change", {
        detail: {
          target: this,
          value: this.selectedIndex
        }
      });
      this.dispatchEvent(e);
    }
  }

  setDisabled(v) {
    this.dropdownElement.disabled = v;
    this.caption.disabled = v;
  }
}
GlobalManagerMixin.call(OptionDropDown.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

/**
 * Creates a footer element to add to this DockingPanel. Footer provides a resize handler.
 * Call this method during initialize() if a standard title bar is desired, and then add it to an existing container.
 * @returns {HTMLElement} The created footer.
 */
export class ResizeFooter {

  constructor(container, resizeCallback, globalManager) {

    this.resizeCallback = resizeCallback;
    this._container = container;

    var _document = this.getDocument();
    var footer = _document.createElement('div');
    footer.classList.add('docking-panel-footer');

    var resizer = _document.createElement("div");
    resizer.classList.add("docking-panel-footer-resizer");

    footer.appendChild(resizer);

    this._iniUpdate = false;
    this._iniPanelSize = container.getBoundingClientRect();
    this._iniMousePosition = { x: 0, y: 0 };

    this._resizeOverlay = _document.createElement('div');
    this._resizeOverlay.classList.add('adsk-viewing-viewer');
    this._resizeOverlay.classList.add('docking-panel-resize-overlay');

    resizer.addEventListener('touchstart', this._onMouseDown);
    resizer.addEventListener('mousedown', this._onMouseDown);

    container.style.resize = 'none';
    container.appendChild(footer);

    this.footer = footer;
    this.resizer = resizer;
  }

  _onMouseDown = (event) => {
    this._iniUpdate = true;
    this._iniPanelSize = this._container.getBoundingClientRect();
    var _document = this.getDocument();
    _document.body.appendChild(this._resizeOverlay);

    this.addDocumentEventListener('touchmove', this._onMouseMove);
    this.addDocumentEventListener('touchcancel', this._onMouseUp);
    this.addDocumentEventListener('touchend', this._onMouseUp);
    this.addDocumentEventListener('mousemove', this._onMouseMove);
    this.addDocumentEventListener('mouseup', this._onMouseUp);

    event.preventDefault();
    event.stopPropagation();
  };

  _onMouseUp = (event) => {
    var _document = this.getDocument();
    if (_document.body.contains(this._resizeOverlay)) {
      _document.body.removeChild(this._resizeOverlay);

      this.removeDocumentEventListener('touchmove', this._onMouseMove);
      this.removeDocumentEventListener('touchcancel', this._onMouseUp);
      this.removeDocumentEventListener('touchend', this._onMouseUp);
      this.removeDocumentEventListener('mousemove', this._onMouseMove);
      this.removeDocumentEventListener('mouseup', this._onMouseUp);

      event.preventDefault();
      event.stopPropagation();
    }
  };

  _onMouseMove = (event) => {
    if (event.type === 'touchmove') {
      event.canvasX = event.touches[0].screenX;
      event.canvasY = event.touches[0].screenY;
    }
    if (this._iniUpdate) {
      this._iniUpdate = false;
      this._iniMousePosition.x = event.canvasX || event.clientX;
      this._iniMousePosition.y = event.canvasY || event.clientY;
    }

    var dx = (event.canvasX || event.clientX) - this._iniMousePosition.x;
    var dy = (event.canvasY || event.clientY) - this._iniMousePosition.y;

    var width = parseInt(this._iniPanelSize.width + dx);
    var height = parseInt(this._iniPanelSize.height + dy);

    this._container.style.width = width + 'px';
    this._container.style.height = height + 'px';

    this.resizeCallback && this.resizeCallback(width, height);

    event.preventDefault();
    event.stopPropagation();
  };
}
GlobalManagerMixin.call(ResizeFooter.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

export class OptionRow {

  constructor(caption, parentTbody, description, globalManager, options) {

    this.tbody = parentTbody;

    var atIndex = options && options.insertAtIndex ? options.insertAtIndex : -1;
    this.sliderRow = this.tbody.insertRow(atIndex);
    this.sliderRow.classList.add("switch-slider-row");

    var _document = this.getDocument();
    var cell = this.sliderRow.insertCell(0);
    this.caption = _document.createElement("div");
    this.caption.setAttribute("data-i18n", caption);
    this.caption.textContent = i18n.t(caption);

    cell.appendChild(this.caption);

    cell = this.sliderRow.insertCell(1);

    if (description) {
      this.description = _document.createElement("div");
      this.description.setAttribute("data-i18n", description);
      this.description.textContent = i18n.t(description);

      cell.appendChild(this.description);
      cell = this.sliderRow.insertCell(2);
    }
  }
}
GlobalManagerMixin.call(OptionRow.prototype);

//==========================================================================================================
//==========================================================================================================
//==========================================================================================================

export class SimpleList {

  constructor(parentDiv, renderListItemFn, onClick) {

    this._parentDiv = parentDiv;
    this._renderRowFn = renderListItemFn;
    this._onClickFn = onClick;
    this._onRowClick = this._onRowClick.bind(this);

    const _document = this.getDocument();
    const container = _document.createElement('div');
    container.classList.add('settings-container');

    this._parentDiv.appendChild(container);
    this._myContainer = container;
    this._myContainer.addEventListener("click", this._onRowClick, { capture: true });

    const envRow = _document.createElement('div');
    envRow.classList.add('settings-table');
    this._rowsContainer = envRow;
    container.appendChild(envRow);
  }

  setData(items, selectionIndex) {
    this._removeAllRows();
    this._items = items;
    for (let i = 0; i < items.length; ++i) {
      this._addRow(i);
    }
    this._updateSelection(selectionIndex);
  }

  // Removes from DOM.
  removeFromParent() {
    this._myContainer.removeEventListener("click", this._onRowClick, { capture: true });
    this._removeAllRows();
    this._parentDiv.removeChild(this._myContainer);
    this._parentDiv = null;
    this._myContainer = null;
    this._rowsContainer = null;
    this._onClickFn = null;
    this._items = null;
  }

  // @private
  _addRow(index) {

    const item = this._items[index];
    const _document = this.getDocument();
    const cell = _document.createElement("div");

    this._renderRowFn(cell, item, { domDocument: _document });

    cell.setAttribute('data-index', index);
    this._rowsContainer.appendChild(cell);
  }

  // @private
  _removeAllRows() {
    var rows = this._rowsContainer.children;
    while (rows.length) {
      this._rowsContainer.removeChild(rows[0]);
    }
  }

  // @private
  _updateSelection(index) {
    const cells = this._rowsContainer.children;
    for (let i = 0; i < cells.length; i++) {
      const cell = cells[i];
      if (i === index) {
        cell.classList.add("border-select");
      } else {
        cell.classList.remove("border-select");
      }
    }
  }

  /**
   * Click handler, routes call to method provided.
   * @private
   */
  _onRowClick(event) {
    var domElem = event.target;
    var attrValue;

    // find the actual row element by traversing up
    while (domElem !== this._myContainer) {
      attrValue = domElem.getAttribute('data-index');
      if (attrValue) {
        break;
      }
      domElem = domElem.parentNode;
    }
    if (attrValue) {
      var index = parseInt(attrValue);
      this._onClickFn(index);
    }
  }

}

GlobalManagerMixin.call(SimpleList.prototype);